/** @format */

export const ID_PARTNER_DISCOUNT_NOTE = 'partner-discount-note';
